import React from 'react';

import {
  DateContainer,
  DayText,
  MonthText,
  TimeText,
  YearText,
} from './styles';

interface MeetingDateProps {
  date: string;
  time: string;
}

const MeetingDate: React.FC<MeetingDateProps> = ({ date, time }) => {
  const d = new Date(date);

  const day = d.getDate().toString().padStart(2, '0');
  const month = d.toLocaleString('default', { month: 'long' });
  const year = d.getFullYear();

  return (
    <DateContainer>
      <DayText>{day}</DayText>
      <MonthText>{month}</MonthText>
      <YearText>- {year} -</YearText>
      <TimeText>{time}</TimeText>
    </DateContainer>
  );
};

export default MeetingDate;
